// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('#tutorial_modal');
    this.render();
  }

  @on({ event: 'change', selector: '#revenue_type' })
  onChangeRevenueType() {
    this.render();
  }

  changeRequired() {}

  render() {
    const type = $('#revenue_type').val();
    $('#subscription_form').toggle(type === 'Subscription');
    $('#product_form').toggle(type === 'Product');
    $('#kpi_form').toggle(type === 'Kpi');

    if (type === 'Subscription') {
      $('#monthly_revenue').prop('required', true);
      $('#initial_users').prop('required', true);
      $('#kpi_growth_rate').prop('required', true);
      $('#selling_price').prop('required', false);
      $('#initial_revenue').prop('required', false);
      $('#cost_of_goods_rate').prop('required', false);
      $('#object_value').prop('required', false);
      $('#kpi_growth_rate').prop('required', false);
    }

    if (type === 'Product') {
      $('#monthly_revenue').prop('required', false);
      $('#initial_users').prop('required', false);
      $('#selling_price').prop('required', true);
      $('#initial_revenue').prop('required', true);
      $('#cost_of_goods_rate').prop('required', true);
      $('#revenue_growth_rate').prop('required', true);
      $('#object_value').prop('required', false);
      $('#kpi_growth_rate').prop('required', false);
    }

    if (type === 'Kpi') {
      $('#monthly_revenue').prop('required', false);
      $('#initial_users').prop('required', false);
      $('#selling_price').prop('required', false);
      $('#initial_revenue').prop('required', false);
      $('#cost_of_goods_rate').prop('required', false);
      $('#object_value').prop('required', true);
      $('#kpi_growth_rate').prop('required', true);
    }
  }
}
